<template>
  <v-layout>
    <v-flex>
      <v-progress-linear
        indeterminate
        color="primary"
        :active="activeBar"
      ></v-progress-linear>
      <v-row justify="center">
        <v-snackbar
          v-model="snackbar"
          :color="snackColor"
          :timeout="timeout"
          top
        >
          {{ alertText }}
          <v-btn dark text @click="snackbar = false">
            Close
          </v-btn>
        </v-snackbar>
      </v-row>
      <v-card class="rounded-border justify-center">
        <v-layout row wrap>
          <v-flex>
            <h3
              class="font-weight-light headline text-md-center"
              v-if="currency == 'INR'"
            >
              Current amount due : ₹ {{ totalAmount }}
            </h3>
            <h3 class="font-weight-light headline text-md-center" v-else>
              Current amount due : $ {{ totalAmount }}
            </h3>
          </v-flex>
        </v-layout>
        <v-card-actions class="justify-center">
          <v-dialog rounded v-model="dialog" persistent max-width="425">
            <template v-slot:activator="{ on }">
              <v-btn rounded pa-2 :disabled="cost" color="primary" v-on="on"
                >Make Payment</v-btn
              >
            </template>
            <v-card>
              <v-img
                :src="require('@/assets/logo.png')"
                height="100"
                width="200"
                contain
              >
              </v-img>
              <v-progress-linear
                indeterminate
                color="primary"
                :active="activeBar"
              ></v-progress-linear>
              <v-divider></v-divider>
              <v-card-title>{{ cardTitle }} </v-card-title>
              <v-card-text>
                {{ payMsg }}
                <v-flex v-if="currency == 'INR'"> ₹ {{ totalAmount }} </v-flex>
                <v-flex v-else> $ {{ totalAmount }} </v-flex>
              </v-card-text>
              <v-card-actions>
                <v-btn
                  rounded
                  color="primary"
                  :disabled="clicked"
                  @click="renewAllService"
                  >Pay</v-btn
                >
                <v-btn rounded color="accent" @click="setValues">Close</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-card-actions>
      </v-card>
      <v-stepper v-model="step" vertical non-linear>
        <v-stepper-header>
          <v-stepper-step class="twhite--text" step="1" editable
            >Current Subscriptions
          </v-stepper-step>
          <v-divider></v-divider>
          <v-stepper-step class="twhite--text" step="2" editable
            >Billing History</v-stepper-step
          >
          <v-divider></v-divider>
        </v-stepper-header>
        <v-stepper-items>
          <v-stepper-content step="1">
            <v-flex ma-4>
              <v-simple-table
                :dense="dense"
                :fixed-header="fixedHeader"
                :height="height"
              >
                <template v-slot:no-data>
                  <v-alert :value="true" color="error" icon="warning">
                    Sorry, nothing to display here :(
                  </v-alert>
                </template>
                <template>
                  <thead>
                    <tr>
                      <th class="text-left">Project ID</th>
                      <th class="text-left">Project Name</th>
                      <th class="text-left">Service Name</th>
                      <th class="text-left">Due Date</th>
                      <th class="text-left">Amount</th>
                      <th class="text-left">Start Date</th>
                      <th class="text-left">End Date</th>
                      <th class="text-left">Pay</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(item, index) in subscriptions" :key="index">
                      <td class="text-xs-center font-weight-regular subheading">
                        {{ item.project_id }}
                      </td>
                      <td class="text-xs-center font-weight-regular subheading">
                        {{ item.project_name }}
                      </td>
                      <td class="text-xs-center font-weight-regular subheading">
                        {{ item.service_id }}
                      </td>
                      <td class="text-xs-center font-weight-regular subheading">
                        {{ item.due_date }}
                      </td>

                      <td
                        class="text-xs-center font-weight-regular subheading"
                        v-if="item.currency == 'INR'"
                      >
                        ₹ {{ item.amount }}
                      </td>
                      <td
                        class="text-xs-center font-weight-regular subheading"
                        v-else
                      >
                        $ {{ item.amount }}
                      </td>
                      <td class="text-xs-center font-weight-regular subheading">
                        {{ item.start_date }}
                      </td>
                      <td class="text-xs-center font-weight-regular subheading">
                        {{ item.end_date }}
                      </td>
                      <td class="text-xs-center font-weight-regular subheading">
                        <v-btn
                          rounded
                          pa-2
                          color="primary"
                          @click="renewSingleService(index)"
                          >Renew</v-btn
                        >
                      </td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
            </v-flex>
          </v-stepper-content>
          <v-stepper-content step="2">
            <v-flex ma-4>
              <v-simple-table
                :dense="dense"
                :fixed-header="fixedHeader"
                :height="height"
              >
                <template v-slot:no-data>
                  <v-alert :value="true" color="error" icon="warning">
                    Sorry, nothing to display here :(
                  </v-alert>
                </template>
                <template>
                  <thead>
                    <tr>
                      <th class="text-left">Date</th>
                      <th class="text-left">Payment ID</th>
                      <th class="text-left">Amount</th>
                      <th class="text-left">Currency</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(item, index) in history" :key="index">
                      <td class="text-xs-center font-weight-regular subheading">
                        {{ item.date }}
                      </td>
                      <td class="text-xs-center font-weight-regular subheading">
                        {{ item.payment_id }}
                      </td>
                      <td class="text-xs-center font-weight-regular subheading">
                        {{ item.total_amount }}
                      </td>
                      <td class="text-xs-center font-weight-regular subheading">
                        {{ item.currency }}
                      </td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
            </v-flex>
          </v-stepper-content>
        </v-stepper-items>
      </v-stepper>
    </v-flex>
  </v-layout>
</template>
<script>
import { db } from "@/Firebase";
import { functions } from "@/Firebase";
export default {
  name: "Billing",
  data: () => ({
    cost: true,
    snackbar: false,
    beforePay: true,
    clicked: false,
    dialog: false,
    activeBar: false,
    payMsg: "Total Amount:",
    cardTitle: "Thanks for trusting us",
    snackColor: "accent",
    timeout: 50000,
    alertText: "",
    totalAmount: 0,
    currency: "INR",
    step: 1,
    dense: false,
    fixedHeader: false,
    height: 300,
    subscriptions: [],
    history: []
  }),
  created() {
    let historyUrl = db.collection("billing").doc(this.$store.state.userId);
    historyUrl
      .collection("history")
      .orderBy("date", "desc")
      .get()
      .then(snapshot => {
        let i = 0;
        snapshot.forEach(doc => {
          this.history[i] = doc.data();
          i++;
        });
      });
    let subscriptionUrl = db
      .collection("subscriptions")
      .doc(this.$store.state.userId);
    subscriptionUrl
      .collection("unpaid")
      .orderBy("start_date", "desc")
      .get()
      .then(snapshot => {
        let i = 0;
        snapshot.forEach(doc => {
          this.subscriptions[i] = doc.data();
          this.subscriptions[i].id = doc.id;
          this.totalAmount += this.subscriptions[i].amount;
          this.beforePay_array[i] = true;
          this.clicked_array[i] = false;
          this.dialog_array[i] = false;
          this.activeBar_array[i] = false;
          (this.payMsg_array[i] = "Total Amount:"),
            (this.cardTitle_array[i] = "Thanks for trusting us"),
            i++;
        });
        if (this.totalAmount > 0) this.cost = false;
        this.activeBar = false;
        this.currency = this.$store.state.currency;
      });
  },
  methods: {
    setValues() {
      this.clicked = false;
      this.beforePay = true;
      this.activeBar = false;
      this.dialog = false;
    },
    setValues_array(index) {
      this.dialog_array[index] = false;
      this.dialog_array1 = false;
      this.clicked_array[index] = false;
      this.beforePay_array[index] = true;
      this.activeBar_array[index] = false;
    },
    renewSingleService(index) {
      var vm = this;
      vm.snackbar = true;
      vm.alertText =
        "Please wait for few minutes, payment gateway will open immediately";
      var getOrderId = functions.httpsCallable("getOrderId");
      getOrderId({
        currency: this.$store.getters.currency,
        amount: this.subscriptions[index].amount * 100,
        uid: this.$store.getters.userId
      })
        .then(result => {
          vm.alertText = "Please wait for few minutes, processing payment";
          var userId = this.$store.state.userId;
          var today = new Date();
          var mon = today.getMonth() + 1;

          var oDate = today.getFullYear() + "-" + mon + "-" + today.getDate();
          oDate = String(oDate);
          var orderDetails = {
            user_id: userId,
            displayName: this.$store.state.displayName,
            subscription: this.subscriptions[index],
            total_amount: this.subscriptions[index].amount * 100,
            currency: this.$store.getters.currency,
            paid_date: oDate,
            user_type: 1,
            payment_gateways: "razorpay"
          };

          var options = {
            callback_url: "https://saascadetech.com",
            key: "rzp_live_TNj6aTAUEyIxLR", // Enter the Key ID generated from the Dashboard
            amount: this.subscriptions[index].amount * 100,
            currency: this.$store.getters.currency,
            order_id: result.data.id,
            payment_capture: 1,
            image: "./assets/logo.png",
            handler: function(response) {
              var renewSingleService = functions.httpsCallable(
                "renewSingleService"
              );
              renewSingleService({
                orderDetails: orderDetails,
                razorpay_payment_id: response.razorpay_payment_id,
                razorpay_order_id: response.razorpay_order_id
              }).then(res => {
                vm.snackbar = true;
                vm.snackColor = "success";
                vm.alertText = res.data.msg;
                var verifySignature = functions.httpsCallable(
                  "verifySignature"
                );
                verifySignature({
                  razorpay_payment_id: response.razorpay_payment_id,
                  razorpay_order_id: response.razorpay_order_id,
                  razorpay_signature: response.razorpay_signature
                }).then(res => {
                  vm.snackbar = true;
                  vm.snackColor = "success";
                  vm.alertText = res.data.msg;
                  window.location.href = "/billing";
                });
              });
            },
            prefill: {
              name: this.$store.getters.displayName,
              email: this.$store.getters.email,
              contact: this.$store.getters.phNumber
            },
            notes: {
              user_id: this.$store.getters.userId,
              total_amount: this.totalAmount * 100,
              currency: this.$store.getters.currency,
              user_type: 1
            },
            theme: {
              color: "#5856E8"
            }
          };
          var rzp1 = new window.Razorpay(options);
          rzp1.open();
        })
        .catch(error => {
          alert("Error " + error);
        });
    },
    renewAllService() {
      var vm = this;
      this.clicked = true;
      this.activeBar = true;
      this.beforePay = false;
      this.payMsg = "Please wait,the payment gateway will open in few seconds";
      var getOrderId = functions.httpsCallable("getOrderId");
      getOrderId({
        currency: this.$store.getters.currency,
        amount: this.totalAmount * 100,
        uid: this.$store.getters.userId
      })
        .then(result => {
          this.payMsg = "Processing your payment";
          var userId = this.$store.state.userId;
          var today = new Date();
          var mon = today.getMonth() + 1;
          var oDate = today.getFullYear() + "-" + mon + "-" + today.getDate();
          oDate = String(oDate);
          var orderDetails = {
            user_id: userId,
            displayName: this.$store.state.displayName,
            subscription: this.subscriptions,
            total_amount: this.totalAmount * 100,
            currency: this.$store.getters.currency,
            paid_date: oDate,
            user_type: 1,
            payment_gateways: "razorpay"
          };

          var options = {
            callback_url: "https://saascadetech.com",
            key: "rzp_live_TNj6aTAUEyIxLR", // Enter the Key ID generated from the Dashboard
            amount: this.totalAmount * 100,
            currency: this.$store.getters.currency,
            order_id: result.data.id,
            payment_capture: 1,
            image: "./assets/logo.png",
            handler: function(response) {
              var renewAllServices = functions.httpsCallable(
                "renewAllServices"
              );
              renewAllServices({
                orderDetails: orderDetails,
                razorpay_payment_id: response.razorpay_payment_id,
                razorpay_order_id: response.razorpay_order_id
              }).then(res => {
                vm.cardTitle = res.data.msg;
                vm.payMsg = "Almost done";
                var verifySignature = functions.httpsCallable(
                  "verifySignature"
                );
                verifySignature({
                  razorpay_payment_id: response.razorpay_payment_id,
                  razorpay_order_id: response.razorpay_order_id,
                  razorpay_signature: response.razorpay_signature
                }).then(res => {
                  vm.cardTitle = res.data.msg;
                  vm.payMsg = "Completed";
                  vm.beforePay = true;
                  vm.dialog = false;
                  window.location.href = "/billing";
                });
              });
            },
            prefill: {
              name: this.$store.getters.displayName,
              email: this.$store.getters.email,
              contact: this.$store.getters.phNumber
            },
            notes: {
              user_id: this.$store.getters.userId,
              total_amount: this.totalAmount * 100,
              currency: this.$store.getters.currency,
              user_type: 1
            },
            theme: {
              color: "#5856E8"
            }
          };
          var rzp1 = new window.Razorpay(options);
          rzp1.open();
        })
        .catch(error => {
          alert("Error " + error);
        });
    }
  }
};
</script>
